import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getProjectSchedules = api(async function getProjectSchedules({ projectId }) {
    if (!projectId) return null
    return query(
        gql`
            query GetProjectSchedules($projectId: String!) {
                getProjectSchedules(projectId: $projectId) {
                        ${SCHEDULE_TYPE_FIELDS} 
                }
            }
        `,
        { projectId },
        { returns: "getProjectSchedules" }
    )
})

export const SCHEDULE_TYPE_FIELDS = `
                    id
                    _id
                    title
                    retired
                    code
                    unitOfMeasure
                    coreTagDescriptions
                    originatingScheduleId
                    originatingScheduleCode
                    originatingScheduleVersion
                    mismatchedVersion
                    nrm {
                        code
                        description
                    }
                    uniclass {
                        code
                        description
                    }
                    version
                    intro {
                        content
                        note
                    }
                    metadata {
                        published
                        publishedBy
                    }
                    type {
                        Name
                    }
                    tasks {
                        id
                        content
                        title
                        note
                        isHeader
                        minutes
                        taskId
                        headerTaskId
                        classification
                        frequency {
                            period
                            interval
                        }
                        skillSet
                        skill {
                            Skilling
                            SkillingCode
                        }
                        unitOfMeasure
                    }
                    legislation {
                        HTML
                        URL
                        ScheduleLegislationID
                    }
                `
